import UserInfoBanner from './UserInfoBanner.container';

export default UserInfoBanner;
